import Tr from 'translations/Translations';
import {ProcedureType} from "./ProcedureType";

export const DemandCategoryType = {
    CLASSIC: "CLASSIC",
    SECTOR: "SECTOR",
    DEFENSE_AND_SECURITY: "DEFENSE_AND_SECURITY",
}
const _TR_PREFIX = 'demand_category_type_';
export const DemandCategoryTypeLabel = (type) => (Tr(_TR_PREFIX + type));


export const DemandCategoryTypesForProcedure = (procedure) =>
    ProcedureType.NATIONAL_SOCIAL_SERVICES === procedure || ProcedureType.EUROPE_SOCIAL_SERVICES === procedure ?
        Object.keys(DemandCategoryType).filter(x => x !== DemandCategoryType.DEFENSE_AND_SECURITY) : Object.keys(DemandCategoryType);